module.exports = __webpack_public_path__ + "static/media/file-upload.370ba720.svg";